import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WorkService {
    constructor(private http: HttpClient) { }
    getCalendar(year:any) {
        return this.http.get<any>(`${environment.apiUrl}/work/calendar?perPage=-1&page=1&year=${year}`)
    }
    getCalendarWeek(week:any, year:any) {
        return this.http.get<any>(`${environment.apiUrl}/work/calendar?perPage=-1&page=1&week=${week}&year=${year}`)
    }
    getCalendarId(id:any) {
        return this.http.get<any>(`${environment.apiUrl}/work/calendar/${id}`)
    }
    postReport(data:any) {
        return this.http.post<any>(`${environment.apiUrl}/work/report`, data)
    }
    getReport(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/work/report?perPage=${perPage}&page=${page}`)
    }
    getReportManage(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/work/report/manage?perPage=${perPage}&page=${page}`)
    }
    editReport(id:string, data:any) {
        return this.http.patch<any>(`${environment.apiUrl}/work/report/${id}`, data)
    }
    getReportId(id:any) {
        return this.http.get<any>(`${environment.apiUrl}/work/report/${id}`)
    }
    deleteReport(id:string) {
        return this.http.delete<any>(`${environment.apiUrl}/work/report/${id}`) ;
    }
}